import { render, staticRenderFns } from "./checkAutoTrans.vue?vue&type=template&id=5950de71&scoped=true&"
import script from "./checkAutoTrans.vue?vue&type=script&lang=js&"
export * from "./checkAutoTrans.vue?vue&type=script&lang=js&"
import style0 from "./checkAutoTrans.vue?vue&type=style&index=0&id=5950de71&lang=less&scoped=true&"
import style1 from "./checkAutoTrans.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5950de71",
  null
  
)

component.options.__file = "checkAutoTrans.vue"
export default component.exports